<template>
  <div class="box18">
    <pageTitle title="高质量课程" text />

    <commonFreeVideo pageName="人工智能开发-AI就业课" :videoList="videoList" />

    <!-- <div class="btn" @click="toLink('https://m.boxuegu.com/')"> -->
    <div class="btn" @click="zixun('获取更多')">
      获取更多
      <span>></span>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commonFreeVideo from "../common/common-free-video.vue";
export default {
  components: {
    pageTitle,
    commonFreeVideo,
  },
  data() {
    return {
      videoList: [
        { lessonName:"机器学习之聚类算法",
          url: "https://m.boxuegu.com/live/detail-5593",
          img: require("../../../assets/coursePage/ai/box18/01.jpg"),
        },
        {     lessonName:"如何提高人工智能开发效率经验",
          url: "https://m.boxuegu.com/freecourse/detail-1561",
          img: require("../../../assets/coursePage/ai/box18/02.png"),
        },
        { lessonName:"用DeepSeek解锁高效办公",
          url: "https://m.boxuegu.com/freecourse/detail-10301",
          img: require("../../../assets/coursePage/ai/box18/03.png"),
        },
        {      lessonName:"爆火出圈的ChatGpt",
          url: "https://m.boxuegu.com/freecourse/detail-1523",
          img: require("../../../assets/coursePage/ai/box18/04.png"),
        },
      ],
    };
  },
  methods: {
    zixun(name) {
         this.mai("人工智能开发-AI就业课","获取更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box18 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/ai/box18/bg.png") no-repeat;
  background-size: cover;

  .btn {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
    color: #165dff;
  }
}
</style>
